import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { ComponentsModule } from '../components/components.module';
import { ForgotPasswordPage } from './forgot-password.page';

@NgModule({
  declarations: [
    ForgotPasswordPage,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    IonicModule,
    RouterModule,
  ],
  exports: [
    ForgotPasswordPage,
  ],
})
export class ForgotPasswordModule { }
